import React, { useState, useRef, useEffect } from "react";
import {
  IconButton,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Autocomplete,
  styled,
  Popper,
  Popover,
  Typography,
  Box,
  List,
  ListItem,
} from "@mui/material";
import contractsIcon from "../../../assets/images/icons/contracts.svg";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { tripsService } from "../../../api/tripsService/tripsServices";
import { ApprovalStatus, StatusOptions } from "../../../types/FilterEnums";
import { driverDrawer } from "../../fleetAndRoute/style";
import TraceabilityPopover from '../../../components/TraceabilityPopover';
import { useBusinessProfile } from "../../../utils/hooks/useBusinessProfile";
/* interface TractorLicensePlateCellRendererProps {
  value: string;
} */

interface TractorLicensePlateCellRendererProps {
  value: string;
  tripId: number;
  equipmentType: "TRAILER" | "TRUCK";
  user: string; // L'utente loggato
  onUpdate: (updatedValue: string) => void; // Funzione per aggiornare il valore nella tabella
  approvalStatus: string;
  vehiclePlateList?: any[]
  trailerPlateList?: any[]
  status: string
  hasDriver?: boolean
  tractorPlateUpdatable?: boolean
  trailerPlateUpdatable?: boolean
}

const TractorLicensePlateCellRenderer: React.FC<
  TractorLicensePlateCellRendererProps
> = ({ value, tripId, equipmentType, user, onUpdate, approvalStatus,vehiclePlateList=[],trailerPlateList=[],status, hasDriver, tractorPlateUpdatable, trailerPlateUpdatable }) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(value);
  const [showDialog, setShowDialog] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [disableBlur, setDisableBlur] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [traceabilityAnchorEl, setTraceabilityAnchorEl] = useState<HTMLElement | null>(null);
  const [traceabilityDialogOpen, setTraceabilityDialogOpen] = useState(false);
  const [traceabilityData, setTraceabilityData] = useState<{
    tripsInfo: Array<{ tmsObjectNumber: string; tripID: number }>;
    platform?: string;
    licensePlate: string;
  }>({ tripsInfo: [], licensePlate: '' });

  const {legacyData} = useBusinessProfile();
  console.log('legacyData',legacyData)

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditedValue(event.target.value);
  };

  const handleSave = async () => {
    try {
      setDisableBlur(true);
      setIsEditing(false);
      setShowDialog(false);

      // Chiamata API
      const response = await tripsService.updateLicensePlate({
        tripID: tripId,
        licensePlate: editedValue,
        equipmentType,
        user,
      });

      // Check traceability response
      if (response.isTraceability === false || (response.isTraceability === null && response.traceabilitySuccess === false)) {
        setTraceabilityData({ 
          tripsInfo: response.tripsInfo || [],
          platform: response.platform || '',
          licensePlate: editedValue
        });
        setTraceabilityDialogOpen(true);
        setTraceabilityAnchorEl(document.body);
      }

      // Aggiorniamo la UI
      onUpdate(response.licensePlate);

      toast.success(t("screens.trips.licensePlate.success"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      toast.error(t("screens.trips.licensePlate.error"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setDisableBlur(false);
    }
  };

  const handleCancel = () => {
    setShowDialog(false);
    setIsEditing(false);
    setEditedValue(value);
    toast.info(t("screens.trips.licensePlate.editCanceled"), {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    if (disableBlur) return;
    if (!containerRef.current?.contains(event.relatedTarget as Node)) {
      if (editedValue !== value) {
        setShowDialog(true);
      } else {
        setIsEditing(false);
      }
    }
  };

  const handleErrorIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
console.log('legacyData',legacyData)
  const CustomPopper = styled(Popper)(driverDrawer.autocompleteOptions);
  return (
    <>
      <div
        ref={containerRef}
        onBlur={handleBlur}
        tabIndex={-1}
        style={{
          height: "40px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {!isEditing && (
          <IconButton
            disabled={tractorPlateUpdatable === false || trailerPlateUpdatable === false || approvalStatus === ApprovalStatus.REJECTED || 
                     status === StatusOptions.COMPLETED || 
                     status === StatusOptions.WAITING_FOR_DOCUMENTATION || 
                     status === StatusOptions.IN_PROGRESS}
            onClick={hasDriver === false ? handleErrorIconClick : handleEditClick}
            size="small"
          >
            {/*DA RIMUOVERE DOPO PROD TECNICO* */}  
            { hasDriver === false ? (
              <ErrorOutlineIcon sx={{ color: '#CF0A2C', width: "20px", height: "20px" }} />
            ) : (
              <img
                src={contractsIcon}
                alt="Contracts Icon"
                style={{ width: "20px", height: "20px", marginRight: "5px", opacity: approvalStatus === ApprovalStatus.REJECTED || status === StatusOptions.COMPLETED || status === StatusOptions.WAITING_FOR_DOCUMENTATION || status === StatusOptions.IN_PROGRESS ? 0.5 : 1 }}
              />
            )}
          </IconButton>
        )}

        {isEditing ? (
          <Autocomplete
            options={equipmentType === "TRUCK" ? vehiclePlateList : trailerPlateList}
            value={editedValue}
            onInputChange={(event, newInputValue) => {
              handleInputChange({ target: { value: newInputValue } } as React.ChangeEvent<HTMLInputElement>);
            }}
            clearOnEscape
            sx={{ minWidth: '130px', height: '30px', fontSize: '12px' }}
            PopperComponent={CustomPopper}
            disableClearable={true}
            forcePopupIcon="auto"
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                value={editedValue}
                onChange={handleInputChange}
                sx={driverDrawer.autocompleteComponent2}
              />
            )}
          />
        ) : (
          <span 
            onClick={( tractorPlateUpdatable === false || trailerPlateUpdatable === false || approvalStatus === ApprovalStatus.REJECTED || 
                     status === StatusOptions.COMPLETED || 
                     status === StatusOptions.WAITING_FOR_DOCUMENTATION || 
                     status === StatusOptions.IN_PROGRESS) ? undefined : handleEditClick}
            style={{
              color: (hasDriver === false || (!editedValue && equipmentType === "TRAILER")) ? '#CF0A2C' : 'inherit',
              fontWeight: (hasDriver === false || (!editedValue && equipmentType === "TRAILER")) ? 'bold' : 'normal',
              cursor: ( tractorPlateUpdatable === false || trailerPlateUpdatable === false ||approvalStatus === ApprovalStatus.REJECTED || 
                      status === StatusOptions.COMPLETED || 
                      status === StatusOptions.WAITING_FOR_DOCUMENTATION || 
                      status === StatusOptions.IN_PROGRESS) ? 'default' : 'pointer'
            }}
          >
            {!editedValue ? t("common.sidebars.addVehicle.addPlate") : editedValue}
          </span>
        )}
      </div>

      {/* Error Popover */}
      {/*DA RIMUOVERE DOPO PROD TECNICO* */}
      {
     
     <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          sx: {
            padding: '12px 16px',
            maxWidth: '300px',
            border: '1px solid #CF0A2C',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#FFFFFF'
          }
        }}
      >
        <Typography sx={{ color: '#333333', fontSize: '14px' }}>
          {t('common.sidebars.addVehicle.unassociatedPlate')}
        </Typography>
      </Popover> }

      {/* Traceability Popover */}
       {/*DA RIMUOVERE DOPO PROD TECNICO* */}
       {
      <TraceabilityPopover
        open={traceabilityDialogOpen}
        anchorEl={traceabilityAnchorEl}
        onClose={() => {
          setTraceabilityDialogOpen(false);
          setTraceabilityAnchorEl(null);
        }}
        data={{
          licensePlate: editedValue,
          platform: traceabilityData?.platform,
          tripsInfo: traceabilityData?.tripsInfo
        }}
      />
      }
      <Dialog open={showDialog} onClose={handleCancel}>
        <DialogTitle>
          {t("screens.trips.tripDialog.confirmSaveChanges")}
        </DialogTitle>
        <DialogContent>
          {t("screens.trips.tripDialog.saveOrDiscardChanges")}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            {t("screens.trips.tripDialog.cancel")}
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            {t("screens.trips.tripDialog.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TractorLicensePlateCellRenderer;
